import React from "react";

const ChakraModal = ({ chakra, onClose }) => {
  if (!chakra) return null;

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-xl shadow-xl max-h-[75vh] w-[100%] sm:max-w-md overflow-y-auto animate-fadeIn"
        style={{ backgroundColor: chakra.color }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="p-6 text-center">
          <h2 className="text-2xl font-bold mb-2 text-white">{chakra.name} Chakra</h2>
          <p className="text-white mb-4 italic">{chakra.quality}</p>
          <p className="text-white text-lg text-justify whitespace-pre-line">
            {chakra.Detail}
          </p>

          <button
            onClick={onClose}
            className="mt-6 px-5 py-2 bg-white text-black font-medium rounded-md hover:bg-gray-100 transition"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChakraModal;
